import { PageWidget } from '@/lib';
import { Page } from '@/lib/components/core/pageItems/page';
import { DownloadEnvReportButton } from '@/lib/components/reports/downloadEnvReportButton';
import { ReportSelect } from '@/lib/components/reports/reportSelect';
import { BasicTable } from '@/lib/components/tables/BasicTable';
import { useGetRapportageArchief } from '@/lib/queries/reports';
import { BasicTableColumn } from '@/lib/types';
import { RapportageArchiefItem } from '@/lib/types/reports';
import { Card, Flex, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ArchiveReportsPage: React.FunctionComponent = () => {
  const { t } = useTranslation('reports');

  const columns: BasicTableColumn<RapportageArchiefItem>[] = [
    { label: t('archive.columns.uoNumber'), dataIndex: 'uoNummer', filterable: true, sortable: true, width: 130 },
    { label: t('archive.columns.companyName'), dataIndex: 'bedrijfsNaam', filterable: true, sortable: true, width: 220 },
    { label: t('archive.columns.reportYear'), dataIndex: 'rapportageJaar', filterable: true, sortable: true, width: 140 },
    { label: t('archive.columns.rekenmotorVersion'), dataIndex: 'rekenmotorVersie', filterable: true, sortable: true, width: 160 },
    { label: t('archive.columns.versionNumber'), dataIndex: 'versieNummer', filterable: true, sortable: true, width: 120 },
    {
      label: t('archive.columns.status'),
      dataIndex: 'isActief',
      filterable: false,
      sortable: true,
      width: 120,
      render: value => (value ? t('archive.active') : t('archive.archived')),
    },
    {
      label: t('archive.columns.submittedAt'),
      dataIndex: 'datumIngediend',
      filterable: false,
      sortable: true,
      width: 150,
      render: value => formatDate(value as string | undefined),
    },
    {
      label: t('archive.columns.calculatedAt'),
      dataIndex: 'datumBerekend',
      filterable: false,
      sortable: true,
      width: 150,
      render: value => formatDate(value as string | undefined),
    },
    {
      label: t('archive.columns.archivedAt'),
      dataIndex: 'gearchiveerdOp',
      filterable: false,
      sortable: true,
      width: 150,
      render: value => formatDate(value as string | undefined),
    },
    {
      key: 'actions',
      dataIndex: 'id',
      label: '',
      width: 80,
      render: (_, record) => (
        <DownloadEnvReportButton reportData={{ id: record?.id, registratieJaar: record?.rapportageJaar, bedrijfsNaam: record?.bedrijfsNaam }} />
      ),
    },
  ];

  return (
    <Page title={t('pages.archiveReports.title')}>
      <Flex vertical gap="large" style={{ width: '100%' }}>
        <PageWidget>
          <Flex vertical gap="middle" style={{ width: '100%' }}>
            <Typography.Paragraph>{t('pages.archiveReports.body')}</Typography.Paragraph>
            <BasicTable<RapportageArchiefItem> loadEntries={useGetRapportageArchief} columns={columns} />
          </Flex>
        </PageWidget>
        <Card title={t('archive.yearlyReports')}>
          <ReportSelect showRekenmotorVersie />
        </Card>
      </Flex>
    </Page>
  );
};

const formatDate = (value?: string): string => (value ? dayjs(value).format('DD-MM-YYYY HH:mm') : '');
